import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { FormContext, FormContextProps } from '~/components';

export const useFormData = (): FormContextProps => {
    const context = useContext(FormContext);
    if (!context) {
        throw new Error('useFormData must be used within a FormProvider');
    }
    return context;
};

export const useRedirectOnRefresh = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const refreshed = sessionStorage.getItem('refreshed');

        if (refreshed) {
            navigate('/');
        } else {
            sessionStorage.setItem('refreshed', 'true');
        }

        return () => {
            sessionStorage.removeItem('refreshed');
        };
    }, [navigate]);
};
